/* Delegation supports Shopify section reloads and filtered collection updates. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-dh-image-toggle]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const media = button.closest('.card__media');
  if (!media) return;
  const alternate = media.classList.toggle('dh-show-alternate');
  button.setAttribute('aria-pressed', String(alternate));
});

// Apply only when the homepage starts with our campaign section.
(() => {
  let resizeObserver;
  const sync = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const firstSection = document.querySelector('#MainContent > .shopify-section');
    const overlay = document.body.classList.contains('dh-page-index') &&
      Boolean(firstSection?.querySelector('.dh-campaign'));
    header.classList.toggle('dh-overlay-header', overlay);
    header.classList.toggle('dh-header-scrolled', window.scrollY > 8);
    const height = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--dh-header-height', `${height}px`);
    resizeObserver?.disconnect();
    if (overlay && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--dh-header-height', `${header.getBoundingClientRect().height}px`);
      });
      resizeObserver.observe(header);
    }
  };
  window.addEventListener('scroll', () => {
    document.querySelector('.dh-overlay-header')?.classList.toggle('dh-header-scrolled', window.scrollY > 8);
  }, { passive: true });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
  document.addEventListener('shopify:section:reorder', sync);
  window.addEventListener('pageshow', sync);
  sync();
})();

(() => {
  let closeTimer;
  let observer;
  let removeBindings = () => {};
  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const init = () => {
    removeBindings();
    observer?.disconnect();
    clearTimeout(closeTimer);
    const header = document.querySelector('.section-header');
    const menus = [...document.querySelectorAll('.dh-nav-menu')];
    if (!header) return;
    let scrim = document.querySelector('.dh-menu-scrim');
    if (!scrim) {
      scrim = document.createElement('button');
      scrim.className = 'dh-menu-scrim';
      scrim.type = 'button';
      scrim.tabIndex = -1;
      scrim.setAttribute('aria-label', 'Close navigation');
      document.body.append(scrim);
    }
    const update = () => {
      document.body.classList.toggle('dh-menu-open', desktop.matches && menus.some(menu => menu.open));
      document.documentElement.style.setProperty('--dh-menu-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      menus.forEach(menu => menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open)));
    };
    const closeAll = () => { menus.forEach(menu => { menu.open = false; }); update(); };
    const bindings = [];
    const bind = (el, event, fn) => { el.addEventListener(event, fn); bindings.push(() => el.removeEventListener(event, fn)); };
    menus.forEach(menu => {
      bind(menu, 'pointerenter', () => {
        if (!desktop.matches || !hover.matches) return;
        clearTimeout(closeTimer);
        menus.forEach(other => { other.open = other === menu; });
        update();
      });
      bind(menu, 'toggle', () => {
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        update();
      });
    });
    bind(header, 'pointerleave', () => {
      if (hover.matches) closeTimer = setTimeout(() => {
        if (!header.contains(document.activeElement)) closeAll();
      }, 140);
    });
    bind(header, 'pointerenter', () => clearTimeout(closeTimer));
    bind(scrim, 'click', closeAll);
    bind(document, 'keydown', event => {
      if (event.key !== 'Escape') return;
      const active = menus.find(menu => menu.open);
      if (active) { closeAll(); active.querySelector(':scope > summary')?.focus(); }
    });
    bind(window, 'resize', () => { if (!desktop.matches) closeAll(); update(); });
    bind(window, 'scroll', update);
    observer = new MutationObserver(update);
    menus.forEach(menu => observer.observe(menu, { attributes: true, attributeFilter: ['open'] }));
    removeBindings = () => { bindings.forEach(remove => remove()); document.body.classList.remove('dh-menu-open'); };
    update();
  };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
  init();
})();
